/**
 * Dải logo khách hàng (`template.html` dòng 776–786).
 *
 * Ba hộp là placeholder dashed CÓ CHỦ Ý — chính bản thiết kế quyết như vậy, không phải chỗ chưa
 * làm xong. Nợ số 2 của design doc §13.
 */
export const socialProof = {
  eyebrow: 'Đang triển khai thử nghiệm cùng ba doanh nghiệp',
  logos: ['Logo khách hàng 01', 'Logo khách hàng 02', 'Logo khách hàng 03'],
  note: 'Tên khách hàng sẽ được bổ sung sau khi có xác nhận.',
};
